/**
 * @deprecated Use translation json file instead
 */
export const ACTIONS = {
  actions: 'Acciones',
  add: 'Crear',
  edit: 'Editar',
  draft: 'Borrador',
  save: 'Guardar',
  finish: 'Finalizar',
  saving: 'Guardando',
  enable: 'Activar',
  disable: 'Desactivar',
  goBack: 'Regresar',
  seeHistory: 'Ver Historia Clínica',
  seeHistoryPdf: 'Ver Historia Clínica en PDF',
  seeRecipe: 'Generar Receta',
  seeFilter: 'Ver filtros'
};

/**
 * @deprecated Use translation json file instead
 */
export enum ActionsEnum {
  actions = 'Acciones',
  add = 'Crear',
  edit = 'Editar',
  save = 'Guardar',
  saving = 'Guardando',
  enable = 'Activar',
  disable = 'Desactivar',
  goBack = 'Regresar',
  seeHistory = 'Ver Historia Clínica',
  seeRecipe = 'Generar Receta'
}
